import gql from 'graphql-tag';

import { PEOPLE_EMPLOYEE_HISTORY_FRAGMENT } from './employeeHistory';

export const PEOPLE_COMPANY_DOCUMENT_FRAGMENT = gql`
	fragment peopleCompanyDocument on CompanyDocument {
		id
		categoryKey
		categoryLabel
		category {
			id
			key
			name
		}
		title
		responsibleEmployee {
			id
			firstName
			lastName
			preferredName
			personalEmail
			position {
				id
				name
			}
			workTenant {
				id
				name
			}
		}
		format
		contentHtml
		s3Key
		fileName
		templateConfig
		formConfig
		version
		publishedAt
		publishedBy {
			id
			firstname
			lastname
		}
		tenants {
			id
			name
		}
	}
`;

export const GET_COMPANY_DOCUMENTS = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: CompanyDocumentFilter
	) {
		getCompanyDocuments(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...peopleCompanyDocument
			}
			count
		}
	}
	${PEOPLE_COMPANY_DOCUMENT_FRAGMENT}
`;

export const GET_COMPANY_DOCUMENT = gql`
	query($id: ID!) {
		getCompanyDocument(id: $id) {
			...peopleCompanyDocument
			draftUpdatedAt
			hasResponses
			versionHistory {
				version
				title
				format
				s3Key
				fileName
				contentHtml
				formConfig
				publishedAt
				publishedBy {
					id
					firstname
					lastname
				}
			}
		}
	}
	${PEOPLE_COMPANY_DOCUMENT_FRAGMENT}
`;

export const GET_COMPANY_DOCUMENT_HISTORY = gql`
	query(
		$companyDocumentId: ID!,
		$page: Int,
		$perPage: Int,
		$sortDirection: Int!,
		$field: String
	) {
		getCompanyDocumentHistory(
			companyDocumentId: $companyDocumentId,
			page: $page,
			perPage: $perPage,
			sortDirection: $sortDirection,
			field: $field
		) {
			items {
				...peopleEmployeeHistory
			}
			count
		}
	}
	${PEOPLE_EMPLOYEE_HISTORY_FRAGMENT}
`;

export const GET_COMPANY_DOCUMENT_ANONYMOUS_RESPONSE_SUMMARY = gql`
	query getCompanyDocumentAnonymousResponseSummary($companyDocumentId: ID!) {
		getCompanyDocumentAnonymousResponseSummary(companyDocumentId: $companyDocumentId) {
			responseCount
			submittedEmployees
			questions {
				questionId
				label
				type
				responseCount
				skippedCount
				answers
			}
		}
	}
`;

export const GET_COMPANY_DOCUMENTS_COUNT = gql`
	query {
		countCompanyDocuments
	}
`;

export const CREATE_COMPANY_DOCUMENT = gql`
	mutation createCompanyDocument($input: CreateCompanyDocumentInput!) {
		createCompanyDocument(input: $input) {
			...peopleCompanyDocument
		}
	}
	${PEOPLE_COMPANY_DOCUMENT_FRAGMENT}
`;

export const MODIFY_COMPANY_DOCUMENT = gql`
	mutation modifyCompanyDocument($input: ModifyCompanyDocumentInput!) {
		modifyCompanyDocument(input: $input) {
			companyDocument: companydocument {
				...peopleCompanyDocument
			}
		}
	}
	${PEOPLE_COMPANY_DOCUMENT_FRAGMENT}
`;

export const DESTROY_COMPANY_DOCUMENT = gql`
	mutation destroyCompanyDocument($id: ID!) {
		destroyCompanyDocument(id: $id)
	}
`;

export const PUBLISH_COMPANY_DOCUMENT = gql`
	mutation publishCompanyDocument($id: ID!) {
		publishCompanyDocument(id: $id) {
			...peopleCompanyDocument
		}
	}
	${PEOPLE_COMPANY_DOCUMENT_FRAGMENT}
`;
